import landingScalesWideTallLayer1 from "./images/landing-scales-wide-tall-layer-1.png";
import landingScalesWideTallLayer2 from "./images/landing-scales-wide-tall-layer-2.png";
import landingScalesWideTallLayer3 from "./images/landing-scales-wide-tall-layer-3.png";
import landingScalesWideTallLayerDev1 from "./images/landing-scales-wide-tall-layer-dev-1.png";
import landingScalesWideTallLayerDev2 from "./images/landing-scales-wide-tall-layer-dev-2.png";
import landingScalesWideTallTopo from "./images/landing-scales-wide-tall-topo.png";
import landingScalesWideTallPipeSeq0 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010_.png";
import landingScalesWideTallPipeSeq1 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__0.png";
import landingScalesWideTallPipeSeq2 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__1.png";
import landingScalesWideTallPipeSeq3 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__2.png";
import landingScalesWideTallPipeSeq4 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__3.png";
import landingScalesWideTallPipeSeq5 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__4.png";
import landingScalesWideTallPipeSeq6 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__5.png";
import landingScalesWideTallPipeSeq7 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__6.png";
import landingScalesWideTallPipeSeq8 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__7.png";
import landingScalesWideTallPipeSeq9 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__8.png";
import landingScalesWideTallPipeSeq10 from "./images/landing-scales-wide-tall-Pipe-2-Seq_2__00000-00010__9.png";

export default {
  v: "5.12.1",
  fr: 30,
  ip: 0,
  op: 180,
  w: 1460,
  h: 720,
  nm: "Brand-Slide-3-seq2-full-size",
  ddd: 0,
  assets: [
    {
      id: "image_0",
      w: 646,
      h: 96,
      u: "",
      p: landingScalesWideTallLayer1,
      e: 0,
    },
    {
      id: "image_1",
      w: 570,
      h: 382,
      u: "",
      p: landingScalesWideTallLayer2,
      e: 0,
    },
    {
      id: "image_2",
      w: 611,
      h: 662,
      u: "",
      p: landingScalesWideTallLayer3,
      e: 0,
    },
    {
      id: "image_3",
      w: 1584,
      h: 878,
      u: "",
      p: landingScalesWideTallLayerDev1,
      e: 0,
    },
    {
      id: "image_4",
      w: 1804,
      h: 924,
      u: "",
      p: landingScalesWideTallLayerDev2,
      e: 0,
    },
    {
      id: "image_5",
      w: 1918,
      h: 1250,
      u: "",
      p: landingScalesWideTallTopo,
      e: 0,
    },
    {
      id: "imgSeq_0",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq0,
      e: 0,
    },
    {
      id: "imgSeq_1",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq1,
      e: 0,
    },
    {
      id: "imgSeq_2",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq2,
      e: 0,
    },
    {
      id: "imgSeq_3",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq3,
      e: 0,
    },
    {
      id: "imgSeq_4",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq4,
      e: 0,
    },
    {
      id: "imgSeq_5",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq5,
      e: 0,
    },
    {
      id: "imgSeq_6",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq6,
      e: 0,
    },
    {
      id: "imgSeq_7",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq7,
      e: 0,
    },
    {
      id: "imgSeq_8",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq8,
      e: 0,
    },
    {
      id: "imgSeq_9",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq9,
      e: 0,
    },
    {
      id: "imgSeq_10",
      w: 1520,
      h: 896,
      t: "seq",
      u: "",
      p: landingScalesWideTallPipeSeq10,
      e: 0,
    },
    {
      id: "sequence_0",
      layers: [
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_0",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 0,
          st: 0,
          op: 1,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_1",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 1,
          st: 1,
          op: 2,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_2",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 2,
          st: 2,
          op: 3,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_3",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 3,
          st: 3,
          op: 4,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_4",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 4,
          st: 4,
          op: 5,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_5",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 5,
          st: 5,
          op: 6,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_6",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 6,
          st: 6,
          op: 7,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_7",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 7,
          st: 7,
          op: 8,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_8",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 8,
          st: 8,
          op: 9,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_9",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 9,
          st: 9,
          op: 10,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_10",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 10,
          st: 10,
          op: 12,
          sr: 1,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: "pos-2",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 40,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 110,
              s: [730, 370, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 180, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 210,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 3,
      nm: "pos-1",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 40,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 110,
              s: [730, 354, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 180, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 210,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: "layer-1.png",
      cl: "png",
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [986, 234, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 15, s: [986, 214, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [323, 48, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [40, 40, 100],
            },
            { t: 15, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 210,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: "layer-2.png",
      cl: "png",
      refId: "image_1",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 0,
              s: [0],
            },
            { t: 10, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [985, 195, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 18, s: [985, 114, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [285, 191, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [30, 30, 100],
            },
            { t: 18, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 210,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: "layer-3.png",
      cl: "png",
      refId: "image_2",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 0,
              s: [0],
            },
            { t: 5, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [988, 476, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 15, s: [988, 526, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [305.5, 331, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [40, 40, 100],
            },
            { t: 15, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 210,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 2,
      nm: "layer-dev-1.png",
      cl: "png",
      parent: 2,
      refId: "image_3",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 25,
              s: [0],
            },
            { t: 30, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 25,
              s: [269, 134, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 40, s: [269, 114, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [792, 439, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 25,
              s: [46, 46, 100],
            },
            { t: 40, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 210,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 2,
      nm: "layer-dev-2.png",
      cl: "png",
      parent: 1,
      refId: "image_4",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 25,
              s: [0],
            },
            { t: 30, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 25,
              s: [254, 118, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 40, s: [254, 128, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [902, 462, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 25,
              s: [53, 53, 100],
            },
            { t: 40, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 210,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: "Universal-Mask",
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [730, 360, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ef: [
        {
          ty: 29,
          nm: "Gaussian Blur",
          np: 5,
          mn: "ADBE Gaussian Blur 2",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Blurriness",
              mn: "ADBE Gaussian Blur 2-0001",
              ix: 1,
              v: { a: 0, k: 30, ix: 1 },
            },
            {
              ty: 7,
              nm: "Blur Dimensions",
              mn: "ADBE Gaussian Blur 2-0002",
              ix: 2,
              v: { a: 0, k: 1, ix: 2 },
            },
            {
              ty: 7,
              nm: "Repeat Edge Pixels",
              mn: "ADBE Gaussian Blur 2-0003",
              ix: 3,
              v: { a: 0, k: 0, ix: 3 },
            },
          ],
        },
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 16,
                    s: [0, 115.117],
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 32,
                    s: [754.236, 115.117],
                  },
                  { t: 40, s: [810.354, 306.117] },
                ],
                ix: 2,
              },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [256.177, 125.559], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Rectangle 2",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [116.07, 202.557], ix: 2 },
              p: {
                a: 1,
                k: [
                  {
                    i: { x: 0.833, y: 0.833 },
                    o: { x: 0.167, y: 0.167 },
                    t: 11,
                    s: [0, -231],
                    to: [0, 0],
                    ti: [0, 0],
                  },
                  { t: 22, s: [0, 0] },
                ],
                ix: 3,
              },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [252.535, -60.722], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Rectangle 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 210,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 0,
      nm: "Pipe-2-Seq 2_[00000-00010].png",
      cl: "png",
      tt: 1,
      tp: 8,
      refId: "sequence_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [985, 421, 0], ix: 2, l: 2 },
        a: { a: 0, k: [760, 448, 0], ix: 1, l: 2 },
        s: { a: 0, k: [50, 50, 100], ix: 6, l: 2 },
      },
      ao: 0,
      tm: {
        a: 1,
        k: [
          {
            i: { x: [0.833], y: [0.833] },
            o: { x: [0.167], y: [0.167] },
            t: 0,
            s: [0],
          },
          { t: 11, s: [0.367] },
        ],
        ix: 2,
        x: "var $bm_rt;\n$bm_rt = loopOut();",
      },
      w: 1520,
      h: 896,
      ip: 0,
      op: 185,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: "Topo-Mask",
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 3,
              s: [978.045, -204.137, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 28, s: [978.045, 382.863, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [195.045, 28.863, 0], ix: 1, l: 2 },
        s: { a: 0, k: [92.547, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ef: [
        {
          ty: 29,
          nm: "Gaussian Blur",
          np: 5,
          mn: "ADBE Gaussian Blur 2",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Blurriness",
              mn: "ADBE Gaussian Blur 2-0001",
              ix: 1,
              v: { a: 0, k: 50, ix: 1 },
            },
            {
              ty: 7,
              nm: "Blur Dimensions",
              mn: "ADBE Gaussian Blur 2-0002",
              ix: 2,
              v: { a: 0, k: 1, ix: 2 },
            },
            {
              ty: 7,
              nm: "Repeat Edge Pixels",
              mn: "ADBE Gaussian Blur 2-0003",
              ix: 3,
              v: { a: 0, k: 0, ix: 3 },
            },
          ],
        },
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [966.09, 633.727], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [195.045, 28.863], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Rectangle 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 210,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 2,
      nm: "topo.png",
      cl: "png",
      parent: 2,
      tt: 1,
      tp: 10,
      refId: "image_5",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 20,
              s: [50],
            },
            { t: 30, s: [20] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [240, 60.248, 0], ix: 2, l: 2 },
        a: { a: 0, k: [959, 625, 0], ix: 1, l: 2 },
        s: { a: 0, k: [50, 50, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 210,
      st: 0,
      bm: 0,
    },
  ],
  markers: [
    { tm: 40, cm: "1", dr: 0 },
    { tm: 180, cm: "2", dr: 0 },
  ],
  props: {},
};
